
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {};
  }
};